import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";


export default function Form() {
    const [captchaValue, setCaptchaValue] = useState(null);
    const [nome, setNome] = useState(null);
    const [sobrenome, setSobrenome] = useState(null);
    const [email, setEmail] = useState(null);
    const [telefone, setTelefone] = useState(null);
    const [mensagem, setMensagem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);

        const formData = new FormData(e.target);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert("Por favor, insira um e-mail válido.");
            setIsLoading(false);
            return;
        }

        const cleanPhone = telefone.replace(/\D/g, "");
        if (cleanPhone.length < 10) {
            alert("Por favor, insira um telefone válido com DDD.");
            setIsLoading(false);
            return;
        }

        if (!captchaValue) {
            alert("Por favor, confirme que você não é um robô.");
            setIsLoading(false);
            return;
        }

        formData.append("g-recaptcha-response", captchaValue);

        const response = await fetch("envio.php", {
            method: "POST",
            body: formData,
        });

        const result = await response.json();
        alert(result.message);

        setNome(null);
        setSobrenome(null);
        setEmail(null);
        setTelefone(null);
        setCaptchaValue(null);
        e.target.reset();

        setIsLoading(false);
    }

    return (
        <Content>
            <form onSubmit={handleSubmit}>
                <h2>ENTRE EM CONTATO</h2>

                <div className="form-name">
                    <input
                        className="input-name"
                        name="nome"
                        type="text"
                        placeholder="Nome"
                        onChange={(e) => setNome(e.target.value)}
                    />
                    <input
                        className="input-name"
                        name="sobrenome"
                        type="text"
                        placeholder="Sobrenome"
                        onChange={(e) => setSobrenome(e.target.value)}
                    />
                </div>

                <input
                    name="email"
                    type="email"
                    placeholder="E-mail*"
                    onChange={(e) => setEmail(e.target.value)}
                />

                <select name="assunto">
                    <option>Selecione o Assunto</option>
                    <option>Quero conhecer o SPC Escola</option>
                    <option>Já sou parceiro e preciso de suporte</option>
                    <option>Outros assuntos</option>
                </select>

                <input
                    name="telefone"
                    type="text"
                    placeholder="Telefone"
                    onChange={(e) => setTelefone(e.target.value)}
                />

                <textarea
                    name="mensagem"
                    type="text"
                    placeholder="Deixe uma mensagem"
                    onChange={(e) => setMensagem(e.target.value)}
                />

                <ReCAPTCHA
                    sitekey="6Ld6gwssAAAAACgVDRYWVUNFlDx1LeWoGtL-aVS4"
                    onChange={(value) => setCaptchaValue(value)}
                />

                <button type="submit" disabled={isLoading}>
                    {isLoading ? "Enviando..." : "ENVIAR AGORA"}
                </button>
            </form>
        </Content>
    );
}



const Content = styled.section`
    background: #ffffff;
    padding: 80px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-family: 'Poppins', sans-serif;

    h2 {
        font-size: 26px;
        font-weight: 700;
        color: #111;
        margin-bottom: 10px;
    }

    form {
        padding: 40px 50px;
        width: 500px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    }

    .form-name {
        display: flex;
        gap: 10px;
        width: 100%;
    }

    .input-name {
        flex: 1;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 15px;
        transition: all 0.3s ease;
        height: 46px;
        box-sizing: border-box;
    }

    input,
    select{
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 15px;
        transition: all 0.3s ease;
        height: 46px;
        box-sizing: border-box;
        appearance: none;
    }

    textarea {
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 15px;
        transition: all 0.3s ease;
        height: 80px;
        box-sizing: border-box;
        appearance: none;
    }

    select {
        background-color: #fff;
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath fill='%23000' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        background-size: 12px 8px;
        padding-right: 35px;
    }

    input:focus,
    select:focus,
    textarea:focus {
        outline: none;
        border-color: #faa936;
        box-shadow: 0 0 6px rgba(250, 169, 54, 0.4);
    }


    button {
        margin-top: 20px;
        background: #faa936;
        border: none;
        padding: 14px 30px;
        color: #111;
        font-weight: 700;
        font-size: 15px;
        border-radius: 4px;
        cursor: pointer;
        transition: background 0.3s ease, color 0.3s ease;
    }

    button:hover {
        background: #111;
        color: #fff;
    }

    @media (max-width: 900px) {
        width: 100vw;
        padding: 0;
        flex-direction: column;
        form {
            width: 90%;
        }
    }
`;